module.exports = __webpack_public_path__ + "img/arrow.e13edfba.svg";